<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" id="ch00_fm04_copy"><a id="page_iv"></a>© 2013 The Johns Hopkins University Press<br/>All rights reserved. Published 2013<br/>Printed in the United States of America on acid-free paper<br/>9 8 7 6 5 4 3 2 1</p>
<p class="copyright">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218-4363<br/><span class="weblink"><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyright1">Turkel, William J. (William Joseph), 1967–</p>
<p class="copyright2">Spark from the deep : how shocking experiments with strongly electric fish powered scientific</p>
<p class="copyright3">discovery / by William J. Turkel.</p>
<p class="copyright2">    pages cm — (Animals, history, culture)</p>
<p class="copyright2">Includes bibliographical references and index.</p>
<p class="copyright2"><span class="small">ISBN</span> 978-1-4214-0981-8 (hardcover : alk. paper) — <span class="small">ISBN</span> 978-1-4214-0994-8 (electronic) —<br/><span class="small">ISBN</span> 1-4214-0981-X (hardcover : alk. paper) — <span class="small">ISBN</span> 1-4214-0994-1 (electronic)</p>
<p class="copyright2">1. Electric fishes. 2. Electricity—Experiments—History. 3. Discoveries in sciences—History.</p>
<p class="copyright3">I. Title.</p>
<p class="copyright3"><span class="small">QL</span>639.1. <span class="small">T</span>87 2013</p>
<p class="copyright3">597—dc23 2012038726</p>
<p class="copyright">A catalog record for this book is available from the British Library.</p>
<p class="copyright"><em>Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or specialsales@press.jhu.edu</em>.</p>
<p class="copyright">The Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?33098802